import { DateFormatPreset, formatDate } from '@procureai/ui-mui';
import { format } from 'date-fns/fp';
import { join, map, pipe } from 'ramda';

export const formatDateIso = format('yyyy-MM-dd');
export const formatDateRange = pipe<[Date[]], string[], string>(
  //
  map((date) => formatDate(DateFormatPreset.TWO_DIGIT, new Date(date))),
  join(' - '),
);
